/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Fe_Not_SharingInputs */

const en_ticket_fe_not_sharing = /** @type {(inputs: Ticket_Fe_Not_SharingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Field engineer is not currently sharing location.`)
};

const ja_ticket_fe_not_sharing = /** @type {(inputs: Ticket_Fe_Not_SharingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技術者は現在、位置情報を共有していません。`)
};

const fr_ticket_fe_not_sharing = /** @type {(inputs: Ticket_Fe_Not_SharingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le technicien ne partage pas sa position pour le moment.`)
};

const de_ticket_fe_not_sharing = /** @type {(inputs: Ticket_Fe_Not_SharingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Servicetechniker teilt aktuell keinen Standort.`)
};

/**
* | output |
* | --- |
* | "Field engineer is not currently sharing location." |
*
* @param {Ticket_Fe_Not_SharingInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_fe_not_sharing = /** @type {((inputs?: Ticket_Fe_Not_SharingInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Fe_Not_SharingInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_fe_not_sharing(inputs)
	if (locale === "ja") return ja_ticket_fe_not_sharing(inputs)
	if (locale === "fr") return fr_ticket_fe_not_sharing(inputs)
	return de_ticket_fe_not_sharing(inputs)
});